type HFetchArgs<B> = {
  url: string;
  method?: 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE';
  payload?: B;
};

export const hFetch = async <T, B = undefined>({ url, method = 'GET', payload }: HFetchArgs<B>) => {
  const response = await fetch(url, {
    method,
    headers: buildHeaders(payload),
    body: payload instanceof FormData ? payload : JSON.stringify(payload),
  });

  if (hasNoContent(response)) return;
  return (await response.json()) as T;
};

const buildHeaders = <B>(payload?: B) => {
  const headers: HeadersInit = {};

  if (!(payload instanceof FormData)) {
    headers['Content-Type'] = 'application/json';
  }

  const csrfToken = document.querySelectorAll('[name="csrf-token"]')[0];
  if (csrfToken && csrfToken instanceof HTMLMetaElement) {
    headers['X-CSRF-TOKEN'] = csrfToken.content;
  }

  return headers;
};

const hasNoContent = (response: Response) => response.status === 204;

export type HError = {
  status: string;
  message: string;
};

type PublishErrorUnlessSuccessArgs = {
  data: HError;
  alertTitle: string;
};

export const publishErrorUnlessSuccess = ({ data, alertTitle }: PublishErrorUnlessSuccessArgs) => {
  if (data?.status === 'error') {
    const root = window.vueApp;
    // To-Do: Update roots type system to understand error()
    // @ts-ignore
    if (root.$refs?.modal) root.$refs.modal.error();
    root.$store.commit('general/showAlert', {
      alertType: 'error',
      alertTitle,
      alertDescription: data.message,
    });
    throw new Error(data.message);
  }
};
